import Link from 'next/link';
import { StatsProps } from 'types/stats';
import { StatsCardList } from '../stats-card-list';
import { ViewOnce } from '../view-once';

import './career-card.scss';

const ACCREDITATION_LINK = 'https://www.bls.gov/ooh/business-and-financial';

type CareerCardListProps = {
  title: string;
  statistics: StatsProps[];
  onView?: () => void;
};

export const CareerCard = ({
  title,
  statistics,
  onView,
}: CareerCardListProps) => (
  <ViewOnce onView={onView}>
    <section className="career-card-list">
      <h3 className="title">{title}</h3>

      <StatsCardList statistics={statistics} />

      <span className="accreditation-link">
        This information is USA-specific can be found at the{' '}
        <Link
          href={ACCREDITATION_LINK}
          target="_blank"
          className="anchor"
          rel="noreferrer"
        >
          Bureau of Labor and Statistics.
        </Link>
      </span>
    </section>
  </ViewOnce>
);
